import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AxiosError } from 'axios';

import { Button } from 'components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from 'components/ui/dialog';
import { PATH_ROUTES } from 'routes/path';

interface ValidationErrorProps {
  open: boolean;
  error: unknown;
  onClose: () => void;
}

export default function ValidationErrorDialog({
  open,
  error,
  onClose,
}: ValidationErrorProps) {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const errorMessage =
    error instanceof AxiosError
      ? (error.response?.data as { error_title: string; error_msg: string })
      : {
          error_title: t('session_validation_fail_title'),
          error_msg: t('session_validation_fail_msg'),
        };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className='max-w-md px-4 py-6 sm:p-8'
        onOpenAutoFocus={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
        hideClose
      >
        <DialogHeader className='my-4 space-y-4'>
          <DialogTitle className='text-center'>
            {errorMessage.error_title}
          </DialogTitle>

          <DialogDescription>{errorMessage.error_msg}</DialogDescription>
        </DialogHeader>

        <div className='space-y-6'>
          <div className='flex justify-center gap-x-4'>
            <Button
              size='sm'
              className='px-12 bg-medsi-blue hover:bg-medsi-blue/80'
              onClick={() => navigate(PATH_ROUTES.LOGIN)}
            >
              {t('ok')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
